<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "API Logs",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "API Logs",
      items: [
        {
          text: "Home",
        },
         {
          text: "Apprehension",
        },
        {
          text: "API Logs",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>